import styled, { css } from 'styled-components'
import { layout, position } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

const shouldForwardProp = prop => {
  return !['notOnBody', 'angle'].includes(String(prop))
}

const notOnBodyCSS = ({ notOnBody }) =>
  notOnBody &&
  css`
    @media screen and (min-width: ${themeGet('breakpoints.2')}) {
      display: flex;
    }
  `

export const Container = styled.div.withConfig({
  shouldForwardProp,
})`
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 10;
  transform: translateY(-50%);

  @media screen and (min-width: ${themeGet('breakpoints.3')}) {
    display: flex;
  }

  ${layout}
  ${position}

  ${notOnBodyCSS}
`

const angleCss = ({ angle }) => angle

export const Content = styled.div.withConfig({
  shouldForwardProp,
})`
  width: 100%;
  height: 100%;
  transform: rotateZ(${angleCss}deg);
  border-radius: 20px;
  background-color: ${themeGet('colors.calculator.dot')};
`
